module.exports = __webpack_public_path__ + "static/media/suber1.5147381b.png";